import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ADMIN, DASHBOARD, DASHBOARD_ADMIN_CONFERENCE_CONFLICTS, LOGIN } from './constants/routes';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Footer from './components/Footer';
import DashboardOverview from './components/dashboard/DashboardOverview';
import StatCrewLayout from './pages/StatCrewLayout';
import StatCrewPage from './pages/StatCrewPage';
import {
  StatCrewAssetsRosterPage,
  StatCrewAssetsSchedulePage,
  StatCrewAssetsXmlPage,
} from './pages/StatCrewAssetPages';
import JobPreviewPage from './pages/JobPreviewPage';
import ConferenceHistoryPage from './pages/ConferenceHistoryPage';
import PostGameSeasonPage from './pages/PostGameSeasonPage';
import StatCrewUploadPage from './components/Statcrewuploadpage';
import StatCrewReviewPage from './components/StatcrewReviewPage';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';
import AdminPortal from './pages/AdminPortal';
import ConferenceConflictsPage from './pages/ConferenceConflictsPage';


function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex flex-col">
        <Routes>
          <Route path="/" element={<Navigate replace to={LOGIN} />} />
          <Route path={LOGIN} element={<Login />} />
          <Route element={<RequireAuth />}>
            <Route path={DASHBOARD} element={<Dashboard />}>
              <Route index element={<DashboardOverview />} />
              <Route path="statcrew" element={<StatCrewLayout />}>
                <Route index element={<StatCrewPage />} />
                <Route path="upload" element={<StatCrewUploadPage />} />
                <Route path="review" element={<StatCrewReviewPage />} />
                <Route path="jobs/:jobId" element={<JobPreviewPage />} />
                <Route path="assets/xml" element={<StatCrewAssetsXmlPage />} />
                <Route path="assets/roster" element={<StatCrewAssetsRosterPage />} />
                <Route path="assets/schedule" element={<StatCrewAssetsSchedulePage />} />
              </Route>
              <Route path="conference-history" element={<ConferenceHistoryPage />} />
              <Route path="post-game-season" element={<PostGameSeasonPage />} />
            </Route>
            <Route element={<RequireAuth />}>
              <Route element={<RequireAdmin />}>
                <Route path={ADMIN} element={<AdminPortal />} />
                <Route path={DASHBOARD_ADMIN_CONFERENCE_CONFLICTS} element={<ConferenceConflictsPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate replace to={LOGIN} />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
